export const AboutPage = () => (
    <div className="container" style={{ minHeight: "80vh", padding: "20px" }}>
      <h1>About Bay Area School Finder</h1>
      <p>This website helps parents in the Bay Area discover and compare private school options. It was built as a personal project to make school research easier and more transparent.</p>
    </div>
);